import { useState, useEffect } from "react";

// MaterialUI
import { Card, CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";

// Layout
import NavTab from "../../layout/NavTab";

// Fetch
import { getOne } from "../../fetchs/get";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { sessionEnd, showSnackbar } from "../../redux/actions/index";

// React router
import { useParams, useLocation } from "react-router-dom";

// Tools
import { useNavigate } from "react-router-dom";
import { IHosting } from "../../interface/hosting";
import HostingDetails from "../../components/Hostings/HostingDetails";

const Hosting = () => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const [hosting, setHosting] = useState<IHosting>();
  const [isModified, setIsModified] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [lotId, setLotId] = useState<string>("");
  const [showDialog, setShowDialog] = useState(false);

  const token = useSelector((state: RootState) => state.user.token);

  const getHosting = () => {
    if (token && params.hostingId) {
      getOne(token, "/hosting/", params.hostingId, setHosting,
        () => dispatch(sessionEnd()), 
        (err: any) => {
          navigate(`/hebergement/`);
          dispatch(showSnackbar("Erreur : " + err?.error, "error"));
        }
      );
    }
  };

  useEffect(() => {
    getHosting();
    if (state === "hostingSuccess") {
      dispatch(showSnackbar("Hébergement créé avec succès", "success"));
    }
  }, []);

  return (
    <Box className="projectPageContainer" component="main" sx={{ bgcolor: '#f1f5f9', minHeight: '100vh' }}>
      <NavTab
        text={"Hébergement : " + (hosting?.name || "Chargement...")}
        hosting={hosting}
        setOpenModal={setOpenModal}
        setLotId={setLotId}
        lotId={lotId}
        showDialog={isModified} // On utilise isModified pour déclencher l'alerte de départ
        displayReturn={true}
      />

      <Card
        elevation={0}
        sx={{
          m: 2,
          p: 3,
          borderRadius: "16px", // Harmonisé avec TaskDetails
          height: "calc(100vh - 140px)",
          display: "flex",
          flexDirection: "column",
          bgcolor: isModified ? "rgba(255,255,255,0.7)" : "white",
          transition: "background-color 0.3s ease",
          border: '1px solid #e2e8f0'
        }}
      >
        {hosting?.client ? (
          <Fade in={true}>
            <Box 
              className="scrollbar-custom"
              sx={{
                overflowY: "auto",
                flexGrow: 1,
                margin: '-10px',
                padding: '10px',
                // Design de la scrollbar invisible ou fine
                '&::-webkit-scrollbar': { width: '6px' },
                '&::-webkit-scrollbar-thumb': { 
                  backgroundColor: '#cbd5e1', 
                  borderRadius: '10px' 
                },
              }}
            >
              <HostingDetails 
                hosting={hosting}
                isModified={isModified}
                setIsModified={setIsModified}
              />
            </Box>
          </Fade>
        ) : (
          <Box sx={{ display: "flex", flexGrow: 1, justifyContent: "center", alignItems: "center", flexDirection: 'column', gap: 2 }}>
            <CircularProgress size={40} thickness={4} sx={{ color: '#3b82f6' }} />
            <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
              Récupération des données...
            </Typography>
          </Box>
        )}
      </Card>
    </Box>
  );
};

export default Hosting;